import { renderCell, valueFormatter } from "./functions";

export const actionsDataGridKey = "actions";

export const hiddenFields = {
  emplid: 'emplid',
}

const columns = [
  {
    headerName: "Foreign Source",
    field: "foreignSourceName",
    flex: 0.2,
  },
  { headerName: "Reporting Period", field: "period" },
  { headerName: "OSU Identifier", field: "osuUniqueID" },
  {
    headerName: "Type",
    field: "type",
    valueFormatter: valueFormatter.type,
    valueGetter: valueFormatter.type,
    flex: 0.1,
  },
  { headerName: "Submitter", field: "nameN" },
  { headerName: "Submitting Unit", field: "submittingUnit" },
  {
    headerName: "Status",
    field: "status",
    valueFormatter: valueFormatter.status,
  },
  {
    headerName: "Country of Attribution",
    field: "countryOfAttribution"
  },
  {
    headerName: "Amount",
    field: "sourceAmount",
    valueGetter: (value) => {
      const isUndefined = !value && value !== 0
      if (isUndefined || isNaN(value)) {
        return null;
      }
      return Number(value)
    },
    valueFormatter: (value) => {
      if (value === null) {
        return "";
      }
      return `$${value}`;
    },
    type: "number",
  },
  {
    headerName: "Year",
    field: "year",
    type: "number",
  },
  {
    headerName: "Emplid",
    field: "emplid",
  },
  {
    headerName: "Actions",
    field: actionsDataGridKey,
    needsApiRef: true,
    renderCell: renderCell.actions,
    sortable: false,
    flex: 0.1,
    hideable: false,
    filterable: false,
    disableColumnMenu: true,
  },
];

let totalFlex = 1;
const explicitFlexColumns = columns.filter((col) => col.flex !== undefined);
const implicitFlexColumns = columns.filter((col) => col.flex === undefined);

const totalExplicitFlex = explicitFlexColumns.reduce(
  (sum, col) => sum + col.flex,
  0
);
if (totalExplicitFlex > totalFlex) {
  totalFlex = totalExplicitFlex * 2;
}
const remainingFlex = Math.max(0, totalFlex - totalExplicitFlex);
const implicitFlexValue =
  implicitFlexColumns.length > 0
    ? remainingFlex / implicitFlexColumns.length
    : 0;

const flexColumns = columns.map((col) => ({
  ...col,
  flex: col.flex !== undefined ? col.flex : implicitFlexValue,
  filterable: col?.filterable === false ? false : true
}));

export { flexColumns as columns };
